import L from 'leaflet';

export function patchLeafletVectorGridFetch() {
  const protobufPrototype = (L as any).VectorGrid?.Protobuf?.prototype;

  if (!protobufPrototype || protobufPrototype.__zoningPalFetchPatch) {
    return;
  }

  const originalGetVectorTilePromise = protobufPrototype._getVectorTilePromise;
  if (typeof originalGetVectorTilePromise !== 'function') {
    return;
  }

  protobufPrototype._getVectorTilePromise = function patchedGetVectorTilePromise(coords: unknown) {
    return originalGetVectorTilePromise.call(this, coords).catch((error: Error) => {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Vector tile fetch failed; rendering an empty tile instead.', error);
      }

      return { layers: {} };
    });
  };

  protobufPrototype.__zoningPalFetchPatch = true;
}
